import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    overflowX: 'auto',
    overflowY: 'hidden',
    minHeight: theme.spacing(50),
    paddingTop: theme.spacing(7),
    backgroundColor: theme.palette.background.paper,

    '& .react-transform-wrapper': {
      width: '100%',
      overflow: 'visible',
      height: `calc(100% - ${theme.spacing(11.5)})`,
    },
  },
}));
